export const logBuildInfo = (): void => {
	if (import.meta.env.DEV) {
		console.info(
			'%c 🛠 Dev Server Running ',
			'background: #1e1e2e; color: #a6e3a1; font-size: 14px; font-weight: bold; padding: 6px 12px; border-radius: 6px; border: 1px solid #a6e3a1;'
		);

		return;
	}

	const version =
		import.meta.env.VUE_APP_MR_TITLE ||
		import.meta.env.VUE_APP_TAG_NAME ||
		import.meta.env.VUE_APP_VERSION;

	console.info(
		`%c 🚀 ${version} (${import.meta.env.VUE_APP_COMMIT_SHORT_SHA})`,
		'background: #1e1e2e; color: #89b4fa; font-size: 12px; font-weight: bold; padding: 4px 10px; border-radius: 6px; border: 1px solid #89b4fa;'
	);
};
